module.exports = __webpack_public_path__ + "img/r-224.c96a4073.jpg";